import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createQueryClient } from './api/query-client';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import './styles.css';

/** One cache for the whole session; AuthProvider empties it when the session ends. */
const queryClient = createQueryClient();

async function boot() {
  // Dev-only fixtures mode (web/DESIGN.md): a fake API and a seeded session so every
  // signed-in screen can be looked at. The branch is dead in production builds, so the
  // dynamic import and everything under src/dev is left out of the bundle.
  if (import.meta.env.DEV && import.meta.env.VITE_FIXTURES) {
    const { installFixtures } = await import('./dev/fixtures');
    installFixtures(import.meta.env.VITE_FIXTURES);
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
